/**
 * Give an Id to Object map and a list of ids, return all matched objects only if all are matched
 * @param objectById
 * @param ids
 * @returns {*}
 */
export function pickObjects(objectById, ids){
  const allIdsAreInObject = _.every(ids, (id) => {
    return parseInt(id) === 0 || !!objectById[id]
  })
  if (allIdsAreInObject) {
    return _.pick(objectById, ids)
  } else {
    return undefined
  }
}


// WEBPACK FOOTER //
// ./src/scripts/utils/StatePicker.js